// ExpenseAmountItem Component

/* eslint indent: 0, react/jsx-indent: 0 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Checkbox from '../../../common/form/checkbox/checkbox.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'

class ExpenseAmountItem extends Component {
  static get propTypes () {
    return {
      expenseItem: PropTypes.object.isRequired,
      className: PropTypes.string,
      children: PropTypes.node,
      hideVat: PropTypes.bool,
      onClosePo: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      expenseItem: null,
      className: '',
      hideVat: false,
      onClosePo: null
    }
  }

  render () {
    const _className = classnames(
      'expenseamount-item',
      {
        hidevat: this.props.hideVat
      },
      this.props.className
    )
    const expenseItem = this.props.expenseItem
    const purchaseOrder = expenseItem.purchaseOrder || null

    return (
      <div className={_className}>
        <div className='content'>
          <div className='title'>
            {expenseItem.budgetItem ? expenseItem.budgetItem.title : '-'}
          </div>
          <p className='info'>
            <span className='label'>
              <IntlMessage ident='expense.form.labelInfoProject' />
            </span>
            <span className='value'>
              {expenseItem.project ? expenseItem.project.title : '-'}
            </span>
            <span className='label'>
              <IntlMessage ident='expense.form.labelClient' />
            </span>
            <span className='value'>
              {expenseItem.project && expenseItem.project.contact
                ? expenseItem.project.contact.company
                : '-'}
            </span>
          </p>
          <p className='info'>
            <span className='label'>
              <IntlMessage ident='expense.form.labelInfoOriginalBudget' />
            </span>
            <span className='value'>
              <PriceText value={expenseItem.budgetItem.total} />
            </span>
          </p>
          <div className='poinfo'>
            {purchaseOrder && purchaseOrder.invoiceNo && (
              <div className='infocol'>
                <span className='polabel'>
                  <span className='pobutton'>
                    {expenseItem.purchaseOrder.invoiceNo}
                  </span>
                </span>
              </div>
            )}
            <div className='infocol'>
              <span className='label'>
                <IntlMessage ident='expense.form.labelOPenPoAmount' />
              </span>
              <span className='value'>
                <PriceText value={expenseItem.openPoAmount} />
              </span>
            </div>
            {purchaseOrder &&
              purchaseOrder.invoiceNo &&
              purchaseOrder.status !== 'Closed' && (
                <div className='infocol'>
                  <Checkbox
                    className='value'
                    label='expense.form.labelClosePo'
                    checked={!!expenseItem.bClosePo}
                    icon='login'
                    onChange={this._onChangeClosePurchaseOrder.bind(
                      this,
                      purchaseOrder
                    )}
                  />
                </div>
              )}
          </div>
        </div>
        <div className='action'>{this.props.children}</div>
      </div>
    )
  }

  _onChangeClosePurchaseOrder (purchaseOrder, bChecked) {
    if (this.props.onClosePo) {
      this.props.onClosePo(purchaseOrder, bChecked)
    }
  }
}

export default ExpenseAmountItem
